import React, { useState } from 'react';
/**
 * Portfolio App - Dynamic Project Experience
 * Interactive storytelling through work showcase
 */
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowLeft, Info } from 'lucide-react';
import { useTheme } from '../../../core/contexts/ThemeContext';
import { ProjectFlow } from './ProjectFlow';
import { ProjectDetail } from './ProjectDetail';
import { InfoOverlay } from './InfoOverlay';
import { projects, Project } from './data/projects';
type ViewState = 'flow' | 'detail' | 'info';
export function PortfolioApp() {
  const {
    getThemeClasses
  } = useTheme();
  const theme = getThemeClasses();
  const [viewState, setViewState] = useState<ViewState>('flow');
  const [activeProject, setActiveProject] = useState<Project | null>(null);
  const [scrollPosition, setScrollPosition] = useState(0);

  // [VERWIJDERD] Er waren geen mousePosition states in deze component, maar de
  // code is geschoond om te garanderen dat er geen overbodige props worden doorgestuurd.

  const handleProjectClick = (project: Project) => {
    setActiveProject(project);
    setViewState('detail');
  };
  const handleBackToFlow = () => {
    setViewState('flow');
    setActiveProject(null);
  };
  const handleInfoClick = () => {
    setViewState('info');
  };
  const handleCloseInfo = () => {
    setViewState(activeProject ? 'detail' : 'flow');
  };
  return <div className={`h-full ${theme.text} ${theme.bg} overflow-hidden relative`} data-id="element-352">
      
      {/* Progress Indicator */}
      <div className={`absolute top-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 ${theme.card} rounded-full px-4 py-2`} data-id="element-353">
        <div className={`w-2 h-2 rounded-full transition-all ${viewState === 'flow' ? 'bg-fuchsia-500 scale-125' : 'bg-white/30'}`} data-id="element-354" />
        <div className={`w-2 h-2 rounded-full transition-all ${viewState === 'detail' ? 'bg-fuchsia-500 scale-125' : 'bg-white/30'}`} data-id="element-355" />
        <div className={`w-2 h-2 rounded-full transition-all ${viewState === 'info' ? 'bg-fuchsia-500 scale-125' : 'bg-white/30'}`} data-id="element-356" />
      </div>
      
      {/* Main Content */}
      <AnimatePresence mode="wait" data-id="element-357">
        {viewState === 'flow' && <ProjectFlow key="flow" projects={projects} onProjectClick={handleProjectClick} scrollPosition={scrollPosition} onScrollChange={setScrollPosition}
      // [VERWIJDERD]: Muispositie en isMobile props worden hier niet meer doorgegeven.
      data-id="element-358" />}
        {viewState === 'detail' && activeProject && <ProjectDetail key="detail" project={activeProject} onBack={handleBackToFlow} onInfoClick={handleInfoClick} data-id="element-359" />}
      </AnimatePresence>
      
      {/* Info Overlay */}
      <AnimatePresence data-id="element-360">
        {viewState === 'info' && activeProject && <InfoOverlay key="info" project={activeProject} onClose={handleCloseInfo} data-id="element-361" />}
      </AnimatePresence>
    </div>;
}